import { SearchFiltersSidebar } from './SearchFiltersSidebar'

export default SearchFiltersSidebar
